/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createGreenhouseJobsAsync } from '../fn/greenhouse/create-greenhouse-jobs-async';
import { CreateGreenhouseJobsAsync$Params } from '../fn/greenhouse/create-greenhouse-jobs-async';
import { getActiveGreenhouseAccountsAsync$Json } from '../fn/greenhouse/get-active-greenhouse-accounts-async-json';
import { GetActiveGreenhouseAccountsAsync$Json$Params } from '../fn/greenhouse/get-active-greenhouse-accounts-async-json';
import { getActiveGreenhouseAccountsAsync$Plain } from '../fn/greenhouse/get-active-greenhouse-accounts-async-plain';
import { GetActiveGreenhouseAccountsAsync$Plain$Params } from '../fn/greenhouse/get-active-greenhouse-accounts-async-plain';
import { getActiveJobGuidsAsync$Json } from '../fn/greenhouse/get-active-job-guids-async-json';
import { GetActiveJobGuidsAsync$Json$Params } from '../fn/greenhouse/get-active-job-guids-async-json';
import { getActiveJobGuidsAsync$Plain } from '../fn/greenhouse/get-active-job-guids-async-plain';
import { GetActiveJobGuidsAsync$Plain$Params } from '../fn/greenhouse/get-active-job-guids-async-plain';
import { GreenhouseAccountCto } from '../models/greenhouse-account-cto';

@Injectable({ providedIn: 'root' })
export class GreenhouseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getActiveGreenhouseAccountsAsync()` */
  static readonly GetActiveGreenhouseAccountsAsyncPath = '/integrations/greenhouse/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveGreenhouseAccountsAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveGreenhouseAccountsAsync$Plain$Response(params?: GetActiveGreenhouseAccountsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GreenhouseAccountCto>>> {
    return getActiveGreenhouseAccountsAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveGreenhouseAccountsAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveGreenhouseAccountsAsync$Plain(params?: GetActiveGreenhouseAccountsAsync$Plain$Params, context?: HttpContext): Observable<Array<GreenhouseAccountCto>> {
    return this.getActiveGreenhouseAccountsAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GreenhouseAccountCto>>): Array<GreenhouseAccountCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveGreenhouseAccountsAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveGreenhouseAccountsAsync$Json$Response(params?: GetActiveGreenhouseAccountsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GreenhouseAccountCto>>> {
    return getActiveGreenhouseAccountsAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveGreenhouseAccountsAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveGreenhouseAccountsAsync$Json(params?: GetActiveGreenhouseAccountsAsync$Json$Params, context?: HttpContext): Observable<Array<GreenhouseAccountCto>> {
    return this.getActiveGreenhouseAccountsAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GreenhouseAccountCto>>): Array<GreenhouseAccountCto> => r.body)
    );
  }

  /** Path part for operation `getActiveJobGuidsAsync()` */
  static readonly GetActiveJobGuidsAsyncPath = '/integrations/greenhouse/companies/{companyGuid}/active-jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveJobGuidsAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveJobGuidsAsync$Plain$Response(params: GetActiveJobGuidsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getActiveJobGuidsAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveJobGuidsAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveJobGuidsAsync$Plain(params: GetActiveJobGuidsAsync$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getActiveJobGuidsAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveJobGuidsAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveJobGuidsAsync$Json$Response(params: GetActiveJobGuidsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getActiveJobGuidsAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveJobGuidsAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveJobGuidsAsync$Json(params: GetActiveJobGuidsAsync$Json$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getActiveJobGuidsAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `createGreenhouseJobsAsync()` */
  static readonly CreateGreenhouseJobsAsyncPath = '/integrations/greenhouse/companies/{companyGuid}/jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGreenhouseJobsAsync()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createGreenhouseJobsAsync$Response(params: CreateGreenhouseJobsAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createGreenhouseJobsAsync(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGreenhouseJobsAsync$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createGreenhouseJobsAsync(params: CreateGreenhouseJobsAsync$Params, context?: HttpContext): Observable<void> {
    return this.createGreenhouseJobsAsync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
